
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

import { Store } from '@ngrx/store';
import { QueryStates } from '../query.reducer';
import * as actions from './../query.actions';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-scenarios',
  templateUrl: './scenarios.component.html',
  styleUrls: ['./scenarios.component.scss']
})
export class ScenariosComponent implements OnInit {
  @Input() viewType = "list"
  @Input() scenarios: any;
  @Output() eventSections = new EventEmitter<any>();

  constructor( private store: Store<QueryStates>) { 
  }

  ngOnInit() {}

  setSections(data) {
    // emite evento al componente padre (query) frente a la seleccion de un escenario.
    this.store.dispatch(actions.setProcessState({stateProcess: 'Set Section' , options: {}}));
    this.eventSections.emit(data);
  }

}
